import Omega3ImageOne from '../../../assets/omega3/1.webp';
import Omega3ImageTwo from '../../../assets/omega3/2.webp';
import Omega3ImageFour from '../../../assets/omega3/4.webp';
import Omega3ImageThree from '../../../assets/omega3/3.webp';
import Omega3ImageOneDe from '../../../assets/omega3/1de.webp';
import Omega3ImageFourDe from '../../../assets/omega3/4de.webp';
import Omega3ImageThreeDe from '../../../assets/omega3/3de.webp';

export const OMEGA3_PRODUCT_TYPE = 'omega-3';

export const OMEGA3_PLAN_KEYS = {
  MONTHLY_SUBSCRIPTION: 'monthly_subscription',
  QUARTERLY_SUBSCRIPTION: 'quarterly_subscription',
  ONE_MONTH_ONE_OFF: 'one_month_one_off',
  THREE_MONTH_ONE_OFF: 'three_month_one_off',
};

export const OMEGA3_DURATION_TO_PLAN_KEY = {
  '1 month': OMEGA3_PLAN_KEYS.MONTHLY_SUBSCRIPTION,
  '3 months': OMEGA3_PLAN_KEYS.QUARTERLY_SUBSCRIPTION,
  '30 days': OMEGA3_PLAN_KEYS.ONE_MONTH_ONE_OFF,
  '90 days': OMEGA3_PLAN_KEYS.THREE_MONTH_ONE_OFF,
};

export const OMEGA3_MEDIA = [
  { id: 'omega3-1', en: Omega3ImageOne, de: Omega3ImageOneDe, altKey: 'Omega3_Media_Alt_Product' },
  { id: 'omega3-2', en: Omega3ImageTwo, de: Omega3ImageTwo, altKey: 'Omega3_Media_Alt_Packaging' },
  { id: 'omega3-3', en: Omega3ImageThree, de: Omega3ImageThreeDe, altKey: 'Omega3_Media_Alt_Softgels' },
  { id: 'omega3-4', en: Omega3ImageFour, de: Omega3ImageFourDe, altKey: 'Omega3_Media_Alt_Lifestyle' },
];

export const OMEGA3_HERO_POINTS = [
  {
    emoji: '🧠',
    titleKey: 'Omega3_Hero_Point_Brain_Title',
    bodyKey: 'Omega3_Hero_Point_Brain_Body',
  },
  {
    emoji: '❤️',
    titleKey: 'Omega3_Hero_Point_Heart_Title',
    bodyKey: 'Omega3_Hero_Point_Heart_Body',
  },
  {
    emoji: '👁️',
    titleKey: 'Omega3_Hero_Point_Vision_Title',
    bodyKey: 'Omega3_Hero_Point_Vision_Body',
  },
];

export const OMEGA3_DIFFERENCE_ITEMS = [
  {
    number: '1',
    eyebrowKey: 'Omega3_Difference_Item_1_Eyebrow',
    titleKey: 'Omega3_Difference_Item_1_Title',
    bodyKey: 'Omega3_Difference_Item_1_Body',
  },
  {
    number: '2',
    eyebrowKey: 'Omega3_Difference_Item_2_Eyebrow',
    titleKey: 'Omega3_Difference_Item_2_Title',
    bodyKey: 'Omega3_Difference_Item_2_Body',
  },
  {
    number: '3',
    eyebrowKey: 'Omega3_Difference_Item_3_Eyebrow',
    titleKey: 'Omega3_Difference_Item_3_Title',
    bodyKey: 'Omega3_Difference_Item_3_Body',
  },
  {
    number: '4',
    eyebrowKey: 'Omega3_Difference_Item_4_Eyebrow',
    titleKey: 'Omega3_Difference_Item_4_Title',
    bodyKey: 'Omega3_Difference_Item_4_Body',
  },
];

export const OMEGA3_BENEFITS = [
  {
    icon: 'brain',
    titleKey: 'Omega3_Benefits_Brain_Title',
    bodyKey: 'Omega3_Benefits_Brain_Body',
  },
  {
    icon: 'heart',
    titleKey: 'Omega3_Benefits_Heart_Title',
    bodyKey: 'Omega3_Benefits_Heart_Body',
  },
  {
    icon: 'vision',
    titleKey: 'Omega3_Benefits_Vision_Title',
    bodyKey: 'Omega3_Benefits_Vision_Body',
  },
];

export const OMEGA3_HOW_TO_STEPS = [
  {
    number: '01',
    titleKey: 'Omega3_HowTo_Step_1_Title',
    bodyKey: 'Omega3_HowTo_Step_1_Body',
  },
  {
    number: '02',
    titleKey: 'Omega3_HowTo_Step_2_Title',
    bodyKey: 'Omega3_HowTo_Step_2_Body',
  },
  {
    number: '03',
    titleKey: 'Omega3_HowTo_Step_3_Title',
    bodyKey: 'Omega3_HowTo_Step_3_Body',
  },
];

export const OMEGA3_INGREDIENT_ROWS = [
  { nameKey: 'Omega3_Ingredients_Row_FishOil', amount: '1000 mg', isTotalRow: true },
  { nameKey: 'Omega3_Ingredients_Row_Epa', amount: '400 mg', isSubRow: true },
  { nameKey: 'Omega3_Ingredients_Row_Dha', amount: '300 mg', isSubRow: true },
  { nameKey: 'Omega3_Ingredients_Row_OtherOmega3', amount: '~100 mg', isSubRow: true },
];

export const OMEGA3_FREE_FROM_KEYS = [
  'Omega3_Ingredients_FreeFrom_Gluten',
  'Omega3_Ingredients_FreeFrom_Dairy',
  'Omega3_Ingredients_FreeFrom_Soy',
  'Omega3_Ingredients_FreeFrom_Colours',
  'Omega3_Ingredients_FreeFrom_Flavours',
  'Omega3_Ingredients_FreeFrom_Preservatives',
];

export const OMEGA3_REVIEWS = [
  {
    name: 'Lena',
    noteKey: 'Omega3_Reviews_Customer_1_Note',
    bodyKey: 'Omega3_Reviews_Customer_1_Body',
  },
  {
    name: 'Jonas',
    noteKey: 'Omega3_Reviews_Customer_2_Note',
    bodyKey: 'Omega3_Reviews_Customer_2_Body',
  },
  {
    name: 'Emma',
    noteKey: 'Omega3_Reviews_Customer_3_Note',
    bodyKey: 'Omega3_Reviews_Customer_3_Body',
  },
];

export const OMEGA3_FAQS = [
  { questionKey: 'Omega3_Faq_1_Question', answerKey: 'Omega3_Faq_1_Answer' },
  { questionKey: 'Omega3_Faq_2_Question', answerKey: 'Omega3_Faq_2_Answer' },
  { questionKey: 'Omega3_Faq_3_Question', answerKey: 'Omega3_Faq_3_Answer' },
  { questionKey: 'Omega3_Faq_4_Question', answerKey: 'Omega3_Faq_4_Answer' },
  { questionKey: 'Omega3_Faq_5_Question', answerKey: 'Omega3_Faq_5_Answer' },
  { questionKey: 'Omega3_Faq_6_Question', answerKey: 'Omega3_Faq_6_Answer' },
];
